import { useContext, useMemo } from "react";
import axios from "axios";
import CountryContext from "../CountryContext";
import { API_URL } from "../utils/constants";
import {
  errorInterceptor,
  requestInterceptor,
  responseInterceptor,
} from "../services/apiRequest";

const useCountryAxiosInstance = (country=null, throwErrorIfCountryNull=true) => {

  const context = useContext(CountryContext);
  const countryCode = country ?? context?.country?.code;

  return useMemo(() => {
    if (!countryCode) {
      if (throwErrorIfCountryNull)
        throw new Error("missing country");
      else
        return null;
    }
  
    const countryApiRequest = axios.create({
      baseURL: `/${countryCode}${API_URL}`,
    });
  
    countryApiRequest.defaults.headers.common["Content-Type"] =
      "application/json";
  
    countryApiRequest.interceptors.request.use(
      requestInterceptor,
      errorInterceptor
    );
  
    countryApiRequest.interceptors.response.use(
      responseInterceptor,
      errorInterceptor
    );
    return countryApiRequest
  }, [countryCode, throwErrorIfCountryNull]);
};

export default useCountryAxiosInstance;
